module.exports = {

  tab :{
    indexw:'Home',
    role:'Role',
    user:'User',
    project:'Project',
    ipmsSource:'IPMS Project Pool',
    task:'Task',
    subtask:'Subtask',
    labour:'LabourHour',
    labourEngineer:'MyLabourHour',
    labourEnter:'LabourLogging',
    holiday:'Holiday',
    cronJob:'Cron Job',
    labourReport:'Labour Hour Report',
    engineerReport:'My Labour Hour Report',
    group:'Group',
    personnel:'Personnel',
    manager:'Project Resource Mgmt.',
    majorProject: 'Project Query',
    project3S2S: '3S2S Project Application',
    projectApplication: 'Project Application',
    projectApproval: 'Project Approval',
    formallyApprovedProject: 'Major Project Initiation',
    keyFocusProjects: 'Key Focus Projects',
    toDo: 'To-Do',
    myFlow: 'My E-flow',
    flowQuery: 'E-flow Query',
    configurationItem: 'Configuration Item',
    projectManagerMaintenance: 'Project Manager Maintenance',
    commonDocuments: 'Project Documents',
    riskManagement: 'Risk Management',
    riskDashboard: 'Risk Dashboard',
    riskAssessmentGuide: 'Risk Assessment Guide',
    informationManagement: 'Information Management',
    documentManagement: 'Document Management',
    valuedAccountReport: 'Valued Account Report',
  },
  //登录页
  innerlogin:'Internal Account Login',
  outterlogin:'External Account Login',
  loginnow:'Sign in',
  languages:'Language',
  domain_account:'Please input the Domain ID',
  loginname:'Please input the Login ID',
  inputUserName:'Please input the User Name',
  enterEmail:'Please input the User Email',
  password:'Please input the Password',
  code:'Verify code',
  forgetPassword:'Forget Password',
  firstLogin:'For the first login, please change the password first',
  oldpwd:'Old Password',
  newpwd:'New Password',
  verifypwd:'Verify Password',
  userAccount:'Account',
  userEmail:'Email',userEmail1:'Email：',
  updatePassword:'Modify Password',
  resetPassword:'Reset Password',
  inputErrorCode:'Verify code error',
  inputErrorCode2:'Verify code cannot be empty',
  loginErrorMsg:'Wrong account or password',
  loginErrorMsg1:'account or password cannot be empty',
  loginErrorMsg2:'Wrong account or password',
  loginErrorMsg3:'Password modify Failed',
  loginErrorMsg4:'Password reset succeeded, new password has been sent to your mailbox',
  loginErrorMsg5:'Failed to send mai',
  loginErrorMsg6:'Email does not match user',
  loginErrorMsg7:'User does not exist',
  loginErrorMsg8:'Two different password entries',
  loginErrorMsg9:'New password cannot be same as original password',
  loginErrorMsg10:'Frozen user cannot Login',
  loginErrorMsg11:'Permission denied. please contact your administrator',
  SystemError:'System Error',
  setLocation:'Set Location',

  //主页面
  login_out:'Sign out',
  pwdEror:'Password Error',
  pwdSuccess:'Password modified successfully',
  TabSelect:'Tab Select',
  clearAll:'Clear All',
  clearOthers:'Clear Others',
  systemtitle:'H3C ISLH System',
  welcomein:'Welcome to ISLH!',
  logintime:'Login Time',

  //角色管理
  conditionRoleName:'RoleName：',
  conditionDes:'RoleDescripetion：',
  conditionStatus:'Status：',
  addRoleInfo:'Add Role',
  updateRoleInfo:'Update Role',
  operateRole:'Operate Role',
  roleName:'Role Name',
  roleDescripe:'Role Descripetion',
  roleState:'Role State',
  permissionSettings:'Permission Settings',
  roleNameNull:'Role name cannot be empty',
  roleDesNull:'Role description cannot be empty',
  saveSus:'Save successful',
  saveFail:'Save failed',
  modifySus:'Modify successful',
  delSus:'Delete successful',
  delMsg:'Are you sure to delete?',
  warnMsg:'Warning',

  //组管理
  conditionGroupName:'GroupName：',
  conditionGroupDes:'GroupDescription：',
  // conditionStatus:'Status：',
  addGroupInfo:'Add Group',
  updateGroupInfo:'Update Group',
  operateGroup:'Operate Group',
  groupName:'Group Name',
  groupDescripe:'Group Descripetion',
  groupState:'Group State',
  // permissionSettings:'Permission Settings',
  groupNameNull:'Group name cannot be empty.',
  groupDesNull:'Group description cannot be empty.',
  countryNull:'Country cannot be empty.',
  groupInfo:'Group Info',
  // userName:'UserName',
  conditionUserName:'UserName：',
  addGroupUserInfo:'Add group member',
  groupUser:'Account：',
  userNameNull:'Group member cannot be empty.',
  groupMemberID:'Group Member Id',
  conditionMemberId:'Member Id：',

  //用户管理
  conditionName:'Name：',
  conditionWorkNumOrZh:'User ID：',
  conditionRegionStatus:'State：',
  conditionType:'User Type：',
  yuNo:'User ID',
  name:'Name',
  createTime:'Creation Time',
  addUserInfo:'Add User',
  updateUserInfo:'Update User',
  innerUser:'Internal User',
  supplierUser:'Supplier User',
  outterUser:'External User',
  conditionWorkNum:'Domain Account：',
  conditionMailbox:'Email：',
  conditionSupplierName:'Supplier Name：',
  userMsg:'The User already exists and cannot be added',
  userMsg1:'Please enter the correct email address',
  emailNull:'Mailbox cannot be empty',
  resetMsg:'Are you sure to reset password?',
  selectMsg:'Please select the Supplier',
  resetMsg1:'You cannot reset internal User password.',
  resetMsg2:'Please choose the user first.',
  resetMsg3:'Please select a user.',
  updateMsg:'You cannot update internal uer info.',
  freezeMsg:'User frozen successfully',
  unFreezeMsg:'User unfreezing succeeded',
  userEmpower:'Empower',
  userRoleEmpower:'Role Permission',
  userDataEmpower:'Data Permission',
  permissionDesc:'Descripetion',
  dataMsg:'Please choose the data first.',
  empowerMsg:'User permissions set successfully.',
  hasRole:'Role',hasRole1:'Role：',
  userLocation:'Location',
  roleAssigned:'Role Assigned',
  additionalRecording:'Authorize Logging privilege',
  //项目经理映射管理
  origin:'Origin',
  salesDepartment:'Sales Department',
  serviceDepartment:'Service Department',
  serviceDeliveryCountry:'Service Delivery Country',
  addManager:'Add Manager',
  originNull:'Origin cannot be empty.',
  businessTypeNull:'Business Type cannot be empty.',
  salesRegionNull:'Sales Region cannot be empty.',
  serviceDeliveryCountryNull:'Service Delivery Country cannot be empty.',
  industryNull:'Industry cannot be empty.',
  salesDepartmentNull:'Sales Department cannot be empty.',
  serviceDepartmentNull:'Service Department cannot be empty.',
  projectManagerNull:'Project Manager cannot be empty.',
  //公共选项
  Total:'Total',
  items:'items',
  operate:'Operation',
  search:'Search',
  add:'Add',
  update:'Edit',
  approve:'Approve',
  delete:'Delete',
  export:'Export',
  trendExport:'Departmental report export',
  import:'Import',
  refresh:'Refresh',
  cancle:'Cancel',
  confrim:'Confirm', 
  return:'Return',
  revoke:'Withdraw',
  enter:'Please enter the content',
  number:'Please enter the Number',
  empower:'Empower',
  freeze:'Freeze',
  unFreeze:'UnFreeze',
  clone:'Clone',
  selectdate:'Please Select Date',
  selectmonth:'Please Select Month',
  save:'Save',
  save_continue:'Save & Continue adding',
  reason:'Please enter the reason',
  closed:'Closed',
  sequnce:'Sequence',
  Yes:'Yes',
  No:'No',
  advancedFilter:'Advanced Filter',
  remark:'Remark',
  select:'Please Select',
  upload:'Upload',
  reportAttachment:'Report & Attachment',
  execute:'Execute',
  download:'Download',
  batchEdit:'Batch Edit',
  batchFrozen:'Freeze',
  batchUnfrozen:'unFreeze',
  beginTime:'Begin Date',
  endTime:'End Date',
  beginMonth:'Begin Month',
  endMonth:'End Month',
  choose:'Choose',


  //项目信息
  addToProject:'Add to project',
  projectPool:'IPMS Project pool',
  projectName:'Project Name',
  projectNumber:'Project Number',
  projectType:'Project Type',
  projectManager:'Project Manager',
  deputyProjectManager:'Deputy Project Manager',
  projectStartDate:'Project Start Date',
  projectEndDate:'Project End Date',
  projectInfo:'Project Info',
  customerInfo:'Account Info',
  contractInfo:'Contract Info',
  projectStatus:'Project Status',
  projectSource:'Project Source',
  businessCategory:'Business Category',
  department:'Department',
  industry:'Industry',
  subcontract:'Subcontract',
  ouEntity:'Ou Entity',
  deliveryType:'Delivery Type',
  projectLevel:'Project Level',
  projectEstimatedEndDate:'Estimated End Date',
  projectActualEndDate:'Actual End Date',
  projectCloseDate:'Close Date',
  beneficialDept:'Beneficial Dept',
  finalBeneficialDept:'Final Beneficial Dept',
  salesMan:'H3C Sales',
  salesRegion:'Sales Region',
  presaleKeyProject:'Presale Major Project',
  postsaleKeyProject:'Postsale Major Project',
  country:'Country',
  beltAndRoad:'B&R',
  subcontractor:'Subcontractor',
  businessType:'Business Type',
  freezingReason:'Freezing',
  unFreezingReason:'unFreezing',
  taskNum:'Task Num',
  subtaskNum:'Subtask Num',
  labourSum:'Labour-hour Sum',
  upstreamSystemId:'Original System ID',
  ipmsProjectCode:'IPMS Code',
  addTask:'Add Task',
  testLeader:'Test Leader',
  testNature:'Test Nature',

  //新增修改展示
  projectStatus1:'Project Status：',
  projectName1:'Project Name：',
  projectNumber1:'Project Number：',
  projectType1:'Project Type：',
  projectManager1:'Project Manager：',
  deputyProjectManager1:'Deputy Project Manager：',
  projectStartDate1:'Project Start Date：',
  projectEndDate1:'Project End Date：',
  businessCategory1:'Business Category：',
  department1:'Department：',
  industry1:'Industry：',
  subcontract1:'Subcontract：',
  ouEntity1:'Ou Entity：',
  deliveryType1:'Delivery Type：',
  projectLevel1:'Project Level：',
  projectEstimatedEndDate1:'Estimated End Date：',
  projectActualEndDate1:'Actual End Date：',
  projectCloseDate1:'Close Date：',
  beneficialDept1:'Beneficial Dept：',
  finalBeneficialDept1:'Final Beneficial Dept：',
  remark1:'Remark：',
  salesMan1:'H3C Sales：',
  salesRegion1:'Sales Region：',
  presaleKeyProject1:'Presale Major Project：',
  postsaleKeyProject1:'Postsale Major Project：',
  postsaleKeyProject2:'Postsale MajorProject：',
  country1:'Country：',
  beltAndRoad1:'B&R：',
  subcontractor1:'Subcontractor：',
  businessType1:'Business Type：',
  upstreamSystemId1:'Original System ID：',
  projectID:'Project ID',
  ipmsProjectCode1:'IPMS Code：',
  addTask1:'Add Task：',
  testLeader1:'Test Leader：',
  testNature1:'Test Nature：',

  //客户信息
   //列表展示
   customerName:'Account Name',
   csiAccountCode:'CSI Account Code',
   customerIndustry:'Account Industry',
   subIndustry:'SubIndustry',
   customerType:'Account Type',
   customerContact:'Contact',
   customerMobile:'Mobile',
   customerAddress:'Address',
   //新增修改展示
   customerName1:'Account Name：',
   csiAccountCode1:'CSI Account Code：',
   customerIndustry1:'Account Industry：',
   subIndustry1:'SubIndustry：',
   customerType1:'Account Type：',
   customerContact1:'Contact：',
   customerMobile1:'Mobile：',
   customerAddress1:'Address：',

   //合同信息
   //列表展示
   serviceContractNo:'Service Contract Number',
   productContractNo:'Product Contract Number',
   purchaseOrderNo:'Purchase Order Number',
   salesOrderNo:'Sales Order Number',
   reseller:'Reseller',
   distributor:'Distributor',
   serviceSalesModule:'Service Sales Module',
   serviceSalesType:'Service Sales Type',
   firstShipmentDate:'First Shipment Date',
   estimatedServiceStartDate:'Estimated Service Start Date',
   serviceDuration:'Service Duration',
   maintenanceStartCondition:'Maintenance Start Condition',
   maintenanceStartDate:'Maintenance Start Date',
   maintenanceEndDate:'Maintenance End Date',
   maintenanceContent:'Maintenance Content',
   amountExdudingTax:'Amount Exduding Tax',
   amountWithTax:'Amount With Tax',
   listPrice:'List Price',
   attachServiceId:'Attach Service Id',
   ibServiceId:'IbService Id',
   orderStatus:'Order Status',
   contactVersionNo:'Contact Version',
   bomCode:'Bom Code',
   bomName:'BOM Name',
   currency:'Currency：',
   //新增修改展示
   serviceContractNo1:'Service Contract Number：',serviceContractNo2:'Service Contract No：',
   productContractNo1:'Product Contract Number：',
   purchaseOrderNo1:'Purchase Order Number：',
   salesOrderNo1:'Sales Order Number：',
   reseller1:'Reseller：',
   distributor1:'Distributor：',
   serviceSalesModule1:'Service Sales Module：',
   serviceSalesType1:'Service Sales Type：',
   firstShipmentDate1:'First Shipment Date：',
   estimatedServiceStartDate1:'Estimated Service Start Date：',
   serviceDuration1:'Service Duration：',
   maintenanceStartCondition1:'Maintenance Start Condition：',
   maintenanceStartDate1:'Maintenance Start Date：',
   maintenanceEndDate1:'Maintenance End Date：',
   maintenanceContent1:'Maintenance Content：',
   amountExdudingTax1:'Amount Exduding Tax：',
   amountWithTax1:'Amount With Tax：',
   listPrice1:'List Price：',
   attachServiceId1:'Attach Service Id：',
   ibServiceId1:'IbService Id：',
   orderStatus1:'Order Status：',
   contactVersionNo1:'Contact Version：',
   bomCode1:'Bom Code：',
   bomName1:'BOM Name：',
   currency1:'Currency：',

   //任务信息
   //列表展示
   taskInfo:'Task Info',
   taskName:'Task Name',
   taskNumber:'Task Number',
   taskOwner:'Task Owner',
   taskStatus:'Task Status',
   taskType:'Task Type',
   serviceContent:'Service Content',
   serviceBom:'Service BOM',
   bomDescription:'BOM Description',
   financialAttributes:'Financial Attributes',
   taskSubcontract:'Subcontract',
   taskSubcontractor:'Subcontractor',
   revenueConfirmationMethod:'Revenue Confirm Method',
   hardwareProductLine:'Hardware ProductLine',
   serviceProductLine:'Service ProductLine',
   productCode:'Product Code',
   taskStartDate:'Start Date',
   taskEndDate:'End Date',
   taskCloseDate:'Close Date',
   deliveryArea:'Delivery Area',
   deliveryLabourHour:'Delivery Labour Hour',
   revenueConfirmationAmount:'Revenue Confirm Amount',
   revenueConfirmationStatus:'Revenue Confirm Status',
   taskAmountWithTax:'Amount With Tax',
   deliveryFinishDate:'Delivery Finish Date',
   subcontractNo:'Subcontract Number',
   serviceQuantity:'Service Quantity',
   taskCompletion:'Task Completion',
   taskReport:'Service Delivery Report',
   addSubtask:'Add Subtask',
   planLabourHour:'Plan Labour Hour',
   //编辑展示
   taskName1:'Task Name：',
   taskNumber1:'Task Number：',
   taskOwner1:'Task Owner：',
   taskStatus1:'Task Status：',
   taskType1:'Task Type：',
   serviceContent1:'Service Content：',
   serviceBom1:'Service BOM：',
   bomDescription1:'BOM Description：',
   financialAttributes1:'Financial Attributes：',
   taskSubcontract1:'Subcontract：',
   taskSubcontractor1:'Subcontractor：',
   revenueConfirmationMethod1:'Revenue Confirm Method：',
   hardwareProductLine1:'Hardware ProductLine：',
   serviceProductLine1:'Service ProductLine：',
   productCode1:'Product Code：',
   taskStartDate1:'Start Date：',
   taskEndDate1:'End Date：',
   taskCloseDate1:'Close Date：',
   deliveryArea1:'Delivery Area：',
   deliveryLabourHour1:'Delivery Labour Hour：',
   revenueConfirmationAmount1:'Revenue Confirm Amount：',
   revenueConfirmationStatus1:'Revenue Confirm Status：',
   taskAmountWithTax1:'Amount With Tax：',
   deliveryFinishDate1:'Delivery Finish Date：',
   subcontractNo1:'Subcontract Number：',
   serviceQuantity1:'Service Quantity：',
   taskCompletion1:'Task Completion：',
   taskReport1:'Service Delivery Report：',
   addSubtask1:'Add Subtask：',
   planLabourHour1:'Plan Labour Hour：',


   //子任务信息
   //列表展示
   subtaskInfo:'Subtask Info',
   subtaskName:'Subtask Name',
   subtaskNumber:'Subtask Number',
   plannedLabourHour:'Planned Labour Hour',
   totalPlannedHour:'Total Labour Hour Planned',
   deliveredLabourHour:'Delivered Labour Hour',
   subtaskStatus:'Subtask Status',
   subtaskType:'Subtask Type',
   actualDeliveryEngineer:'Actual Delivery Engineer',
   deliveryEngineerCity:'Delivery City',
   deliveryAddress:'Delivery Address',
   subtaskEstimatedStartDate:'Estimated Start Date',
   subtaskEstimatedEndDate:'Estimated End Date',
   serviceStartDate:'Service Start Date',
   serviceEndDate:'Service End Date',
   subtaskCloseDate:'Subtask Close Date',
   plannedDate:'Planned Date',
   deliveryFinishedDate:'Delivery Finished Date',
   isStationin:'Is Inhouse',
   subtaskDeliveryType:'Subtask Delivery Type',
   subtaskCompletion:'Subtask Completion',
   addLabour:'Add LabourHour',
   subtaskReport:'Onsite technical service report',
   selectSubtask:'Select Subtask',
   subtaskRemark:'Subtask Description',
   //编辑展示
   subtaskName1:'Subtask Name：',
   subtaskNumber1:'Subtask Number：',
   plannedLabourHour1:'Planned Labour Hour：',
   totalPlannedHour1:'Total Labour Hour Planned：',
   deliveredLabourHour1:'Delivered Labour Hour：',deliveredLabourHour2:'Leave Hour：',
   subtaskStatus1:'Subtask Status：',
   subtaskType1:'Subtask Type：',
   actualDeliveryEngineer1:'Actual Delivery Engineer：',actualDeliveryEngineer2:'Delivery Engineer：',
   deliveryEngineerCity1:'Delivery City：',
   deliveryAddress1:'Delivery Address：',
   subtaskEstimatedStartDate1:'Estimated Start Date：',
   subtaskEstimatedEndDate1:'Estimated End Date：',
   serviceStartDate1:'Service Start Date：',
   serviceEndDate1:'Service End Date：',
   subtaskCloseDate1:'Subtask Close Date：',
   plannedDate1:'Planned Date：',
   deliveryFinishedDate1:'Delivery Finished Date：',
   isStationin1:'Is Inhouse：',
   subtaskDeliveryType1:'Subtask Delivery Type：',subtaskDeliveryType2:'Delivery Type：',
   subtaskCompletion1:'Subtask Completion：',
   addLabour1:'Add LabourHour：',
   subtaskReport1:'Onsite technical service report：',
   subtaskRemark1:'Subtask Describe：',
   


   //工时信息
   //列表展示
   labourInfo:'Labour Hour Info',
   labourHourId:'Labour Hour No',
   workDate:'Work Date',
   workContent:'Work Content',
   workDescribe:'Description',
   workHours:'Work Hours',
   travelHours:'Traveling Hours',
   refreshDate:'Refresh Date',
   ocmsCaseNumber:'OCMS Case Number',ocmsCaseNumber2:'OCMS/NEC Case Number',
   accountName:'Account Name',
   labourStatus:'LabourHour Status',
   pasvno:'Project No./ Service contract No.',
   hourEntry:'Labour hour entry',
   workSummary:'Work hour summary',
   travelSummary:'Travel hour summary',
   totalHours:'Total labour hours',
   ProductLine:'Product Line',
   //编辑展示
   workDate1:'Work Date：',
   workContent1:'Work Content：',
   workDescribe1:'Description：',
   workHours1:'Work Hours：',
   travelHours1:'Traveling Hours：',
   refreshDate1:'Refresh Date：',
   ocmsCaseNumber1:'OCMS Case Number：',
   accountName1:'Account Name：',
   labourStatus1:'LabourHour Status：',
   workMonth1:'Work Month：',
   representativeSupport: 'Representative Support',

   //假期日历
   holidayDate:'Holiday Calendar',
   isHoliday:'Is Holiday',


   //附件
   fileSourceName:'Task/Subtask Name',
   fileName:'File Name',
   fileSource:'File Source',
   createUser:'Creation User',


   //定时job
   jobValue:'Job Value',
   isvalid:'Is Execute',
   runtime:'Run Time',
   nextRuntime:'Next Runtime',
   cycelTime:'Run Cycel',
   jobTime:'CRON',
   jobDesc:'Job Desc',
   //编辑
   jobValue1:'Job Value：',
   isvalid1:'Is Execute：',
   runtime1:'Run Time：',
   nextRuntime1:'Next Runtime：',
   cycelTime1:'Run Cycel：',
   jobTime1:'CRON：',
   jobDesc1:'Job Desc：',


   //报表
   labourHours:'Labour Hours',
   reportMonth:'Personnel report：',
   trendMonth:'Departmental report：',
   empCode:'Account',
   holidayDays:'Days of public holiday',
   workDays:'Days of Working',
   standardHours:'Standard Labour hours',
   saturatedHours:'Saturated Labour hours',
   saturationPercent:'Saturability',
   
   marketFee:'Market support Labour hours',
   marketPercent:'Market support percentage',
   contractFee:'Contract delivery Labour hours',
   contractPercent:'Contract delivery percentage',
   warrantyFee:'Warranty Labour hours',
   warrantyPercent:'Warranty percentage',
   serviceFee:'Service sales Labour hours',
   servicePercent:'Service sales percentage',
   generalFee:'General work Labour hours',
   generalPercent:'General work percentage',

   //产品清单
   inventory:'Inventory',
   productBom:'Product Bom',
   productName:'Product Name',
   productDesc:'Product Describe',
   
   //个人信息
   userId:'User ID',
   employeeId:'Employee ID',
   employeeName:'Employee Name',
   laborRate:'Labor Rate',
   labourRateType:'Labour Rate Type',
   currency2:'Currency',
   createBy:'Create By',
   updateBy:'Update By',
   createDt:'Create Dt',
   updateDt:'Update Dt',
   dataStatus:'Data Status',
   islhToken:'islhToken',

   employeeName1:'Employee Name：',
   labourRateType1:'Labour Rate Type：',
}


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/en.js